// (function (root) {
//     root.gbText = gbText
// })(this)

import { TPPageState } from "./TPPageState.es2023.js";

// gb: 1 or 0 2020/11 繁簡合併
export function gbText(str, gb = null) {
    if (gb == null) {
        gb = TPPageState.s.gb;
    }

    if (gb != 1) { return str; }

    var r1 = {
        "設定": "设定",
        "原文編號": "原文编号",
        "即時SN": "即时SN",
        "繁簡切換": "繁简切换",
        "TSK顯示模式": "TSK显示模式",
        "地圖顯示": "地图显示",
        "圖片顯示": "图片显示",
        "字體大小": "字体大小",
        "整體大小": "整体大小",
        "經文": "经文",
        "希伯來文": "希伯来文",
        "希臘文": "希腊文",
        "我的組合": "我的组合",
        "介面 (左欄、譯本名稱、分頁標籤、按鈕) 是基準，經文、原文、SN 都相對於它。整體大小跟坐得近或遠、眼力、螢幕有關，設一次就好 (側邊欄的 A− A+ 就是這個)。": "界面 (左栏、译本名称、分页标签、按钮) 是基准，经文、原文、SN 都相对于它。整体大小跟坐得近或远、视力、屏幕有关，设一次就好 (侧边栏的 A− A+ 就是这个)。",
        "情境是經文、原文、SN 相對於介面的比例，切換不會改整體大小，也不動介面。停在情境上可看各項大小；右鍵 (手機長按) 側邊欄的 ⚙ 可快速切換。": "情境是经文、原文、SN 相对于界面的比例，切换不会改整体大小，也不动界面。停在情境上可看各项大小；右键 (手机长按) 侧边栏的 ⚙ 可快速切换。",
        "整體大小：介面、經文、原文、SN 一起放大縮小": "整体大小：界面、经文、原文、SN 一起放大缩小",
        "主題": "主题",
        "自動": "自动",
        "淺色": "浅色",
        "高對比": "高对比",
        "跟隨系統的淺色 / 深色、增強對比": "跟随系统的浅色 / 深色、增强对比",
        "自動時跟隨系統的「增強對比」": "自动时跟随系统的「增强对比」",
        "文字、線條對比較高": "文字、线条对比较高",
        "聖經譯本選擇": "圣经译本选择",
        "歷史記錄": "历史纪录",
        "清除記錄": "清除记录",
        "經卷選擇": "经卷选择",

        "整卷聖經": "整卷圣经",
        "摩西五經": "摩西五经",
        "舊約歷史書": "旧约历史书",
        "詩歌智慧書": "诗歌智慧书",
        "大先知書": "大先知书",
        "小先知書": "小先知书",
        "福音書": "福音书",
        "新約歷史書": "新约历史书",
        "保羅書信": "保罗书信",
        "其他書信": "其他书信",
        "舊約": "旧约",
        "新約": "新约",
        "歷史書": "历史书",
        "其它書信": "其它书信",
        "路加著作": "路加著作",
        "約翰著作": "约翰著作",
        "搜尋": "搜寻",
        "關鍵字、G80、羅1:3": "关键字、G80、罗1:3",
        "搜尋失敗": "搜寻失败",
        "無法搜尋": "无法搜寻",
        "原文結果太多，未列入": "原文结果太多，未列入",
        "查無資料": "查无资料",
        "目前閱讀的書卷": "目前阅读的书卷",
        "關鍵字、G80、#羅 1:3|": "关键字、G80、#罗 1:3|",
        "預言書": "预言书",
        "交錯（段落）": "交错（段落）",
        "併排（段落）": "并排（段落）",
        "交錯（單節）": "交错（单节）",
        "併排（單節）": "并排（单节）",
        "交互參照方法": "交互参照方法",

        "背景資料": "背景资料",
        "返回註釋": "返回注释",
        "施工中...": "施工中...",
    };

    for (var a1 in r1) {
        if (str === a1) {
            return r1[a1];
        }
    }
    return str;
}
